import Header from "../components/Header";

export default function Home(){
    return (
        <>
        <Header />
        <h2> 404 </h2>  
        </>
    )
} 